import CreditCardsContainer from "./CreditCardsContainer";

const CreditCards = (props) => {
  return <CreditCardsContainer {...props} />;
};
export default CreditCards;
